import { render, staticRenderFns } from "./Kid.vue?vue&type=template&id=1a217916&"
import script from "./Kid.vue?vue&type=script&lang=js&"
export * from "./Kid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports